import buttonLinkedin from '@assets/button-linkedin.svg';
import buttonMail from '@assets/button-mail.svg';
import buttonX from '@assets/button-x.svg';
import { SocialButtonItemType } from '@data/types';
import React from 'react';
import { currentUrl, shareCurrentUrl } from 'utilities/helper';

interface Props extends SocialButtonItemType {}

const SocialButtonItem: React.FC<Props> = ({ type }) => {
  let img: string = '';

  switch (type) {
    case 'linkedin':
      img = buttonLinkedin;
      break;

    case 'twitter':
    case 'x':
      img = buttonX;
      break;

    case 'email':
    default:
      img = buttonMail;
  }

  return (
    <li>
      <a
        href={shareCurrentUrl(document.title, type, currentUrl())}
        target="_blank"
        title={`Share page via ${type}`}
        rel="noreferrer"
      >
        <img src={img} alt={type} />
      </a>
    </li>
  );
};

export default SocialButtonItem;
